import { when, set } from 'cerebral/operators'

export default [
  when('state:mail.groups.snackbar.show', [true]),
  {
    true: [set('mail.groups.snackbar.show', false)],
    otherwise: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/mail/chains/hideMailGroupSnackbar.js